import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.first_name'
  }),
  intl.formatMessage({
    id: 'table.last_name'
  }),
  intl.formatMessage({
    id: 'table.registration_date'
  }),
  intl.formatMessage({
    id: 'table.email'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.coordinator'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [
        get(item, 'awardLeaderRegistration.globalId') ||
          get(item, 'awardLeaderRegistration.id'),
        get(item, 'awardLeaderRegistration.firstName'),
        get(item, 'awardLeaderRegistration.lastName'),
        get(item, 'awardLeaderRegistration.creationDate'),
        get(item, 'awardLeaderRegistration.email'),
        get(item, 'awardLeaderRegistration.awardLeader.organization.name'),
        get(item, 'awardLeaderRegistration.isCoordinator')
      ]
    }
  })
